<template>
  <div class="flex px-10 py-6 bg-[#F9FBFD] items-center justify-between">
    <div class="w-[420px]">
      <TextInput
        v-model="searchQuery"
        data-testid="my-calendar.task-filter.search-input"
        placeholder="Search Your Task"
        clearable
        @input="handleSearch"
      >
        <template #suffix>
          <img src="@/assets/MyPatient/search.svg" alt="search" />
        </template>
      </TextInput>
    </div>
    <div class="flex gap-6">
      <div class="w-[166px] ">
        <SingleSelector
          data-testid="my-calendar.task-filter.due-date-filter-select"
          class="task-filter"
          :placeholder="'Filter Due Date'"
          :options="dueDateOptions"
          clearable
          size="medium"
          :model-value="selectedDueDate"
          @update:model-value="handleDueDateChange"
        />
      </div>
      <!-- <div class="w-[180px] ">
        <SingleSelector 
          class="task-filter"
          :placeholder="'Filter Creation Date'"
          :options="creationDateOptions"
          :model-value="selectedCreationDate"
          @update:model-value="handleCreationDateChange"
        />
      </div> -->
      <div>
        <ResponsiveButton
          data-testid="my-calendar.task-filter.add-new-task-btn"
          button_type="outlined"
          built_in_theme="dark"
          size="medium"
          display_name="Add New Task"
          class="task-btn"
          @click-button="emit('open-create-task')"
        >
          <template #prefix>
            <img class="w-5 h-5 rotate-45" src="@/assets/my-calendar/close.svg" alt="plus" />
          </template>
        </ResponsiveButton>
      </div>
    </div>
    

  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import moment from 'moment-timezone';
import { useStore } from 'vuex'
const store = useStore()
const emit = defineEmits(['open-create-task','filter-search','filter-due-date','filter-creation-date'])

const selectedDueDate = ref('')
const selectedCreationDate = ref('')
const searchQuery = ref('')
const calendarTimezone = computed(() => store.getters['calendar/calendarTimezone'])

const handleSearch = (value) => {
  // searchQuery.value = value.data
  console.log(searchQuery.value,'searchQuery.value')
  emit('filter-search', searchQuery.value)
}

const handleDueDateChange = (value) => {
  selectedDueDate.value = value
  emit('filter-due-date', value)
}
const handleCreationDateChange = (value) => {
  selectedCreationDate.value = value
  emit('filter-creation-date', value)
}
const dueDateOptions = computed(() => {
  const uniqueDates = new Set();
  return store.state.calendar.rawTaskInfoList
    .map(task => {
      const date = task.due_date;
      const momentDate = moment(date);
      if (!momentDate.isValid()) return null;
      return {
        label: moment.utc(date).tz(calendarTimezone.value).format('YYYY-MM-DD'),
        value: moment.utc(date).tz(calendarTimezone.value).format('YYYY-MM-DD'),
      };
    })
    .filter(option => option && !uniqueDates.has(option.value) && uniqueDates.add(option.value))
    .sort((a, b) => moment(b.label).valueOf() - moment(a.label).valueOf()); 

});

const creationDateOptions = computed(() => {
  const uniqueDates = new Set();
  return store.state.calendar.rawTaskInfoList
    .map(task => {
      const date = task.created_at;
      const momentDate = moment(date);
      if (!momentDate.isValid()) return null;
      return {
        label: moment.utc(date).tz(calendarTimezone.value).format('YYYY-MM-DD'),
        value: moment.utc(date).tz(calendarTimezone.value).format('YYYY-MM-DD'),
      };
    })
    .filter(option => option && !uniqueDates.has(option.value) && uniqueDates.add(option.value))
    .sort((a, b) => moment(b.label).valueOf() - moment(a.label).valueOf()); 

});


</script>

<style scoped>
.task-filter :deep(.el-select__wrapper) {
  height: 40px;
}
.task-btn {
  padding:8px 12px;
}
</style>
